import api from './'

export default {

    /**
     * Get list of payment transactions
     * @param params
     */
    get(params) {
        return api
            .get(`/paymentTransactions`, {
                params: params
            })
            .then(response => {
                return response.data
            });
    },

    /**
     * Show payment transaction
     * @param paymentTransaction
     * @param params
     */
    show(paymentTransaction, params) {
        return api
            .get(`/paymentTransactions/${paymentTransaction}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Refund payment transaction
     * @param paymentTransaction
     * @param data
     */
    refund(paymentTransaction, data) {
        return api
            .post(`/paymentTransactions/${paymentTransaction}/refund`, data)
            .then(response => {
                return response.data
            })
    }

}
